module.exports = __webpack_public_path__ + "static/media/V-ID-6.962e20bb.mp4";